/** Retry the authored rendition; never silently replace its emotion with neutral. */
export async function prepareAuthoredAudio<T>(
  sentence: { text: string; synthesisOptions: Record<string, unknown> },
  prepare: (options: Record<string, unknown>) => Promise<T>,
  waitBeforeRetry: () => Promise<void> = () => new Promise(resolve => setTimeout(resolve, 350)),
): Promise<T> {
  let failure: unknown;
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      return await prepare(sentence.synthesisOptions);
    } catch (error) {
      failure = error;
      // The scene queue handles explicit provider cooldowns. Preserve their
      // codes, and never immediately replay a potentially billable Gemini call.
      if (error && typeof error === "object" && "code" in error && (String(error.code).startsWith("GEMINI_")||error.code==='LOCAL_AUDIO_PROCESSING')) throw error;
      if (error && typeof error === "object" && "retryable" in error && error.retryable === false) break;
      if (attempt === 0) await waitBeforeRetry();
    }
  }
  if (sentence.synthesisOptions.ted_intonation || sentence.synthesisOptions.gemini_intonation) {
    throw new Error(
      `Emotional audio could not be generated for “${sentence.text.slice(0, 100)}”. Playback stopped; no neutral audio was substituted. Please try again.`,
    );
  }
  throw failure instanceof Error ? failure : new Error("The audio preview service could not generate this block.");
}
